module.exports = __webpack_public_path__ + "static/media/hannah.c08695dd.jpg";